import React, { useLayoutEffect, useRef, useState } from "react";

// TZ10-4: описание в карточке витрины — clamp 3 строки, раскрытие на месте
export const TaskDescription = ({ text, taskId }) => {
  const ref = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [overflowing, setOverflowing] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (el && !expanded) setOverflowing(el.scrollHeight - el.clientHeight > 2);
  }, [text, expanded]);

  return (
    <div className="mb-4" data-testid={`task-description-${taskId}`}>
      <p
        ref={ref}
        data-testid="task-description-text"
        data-expanded={expanded ? "true" : "false"}
        className={`text-sm leading-relaxed break-words whitespace-pre-line ${expanded ? "" : "line-clamp-3"}`}
        style={{ color: "var(--rv-text-secondary)" }}
      >
        {text}
      </p>
      {(overflowing || expanded) && (
        <button
          type="button"
          data-testid="task-description-toggle"
          onClick={() => setExpanded((v) => !v)}
          className="mt-1 text-xs font-medium hover:underline"
          style={{ color: "var(--rv-teal)", background: "none", border: "none", cursor: "pointer", padding: 0 }}
        >
          {expanded ? "Свернуть" : "Показать полностью"}
        </button>
      )}
    </div>
  );
};
